import React, { Component } from 'react'

export default class WorksOnoreArmi extends Component {
    render() {
        return (
            <div class="modal" id="worksonorearmi" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;L'onore delle
        armi&quot; </strong>(romanzo): <em>Bompiani, 1997, Milano.</em><br /> <br />Finalista
                                                                                                                                                                                                                                                                                                        Premio Rea. Vincitore Premio città di Catanzaro.
        Vincitore Premio Grinzane Cavour.</h5>
                           
                        </div>
                        <div class="modal-body p-4" id="result">


                            <div align="left">



                                <strong>ne hanno scritto:</strong> <br /><br />

                                Marino Sinibaldi, L'Unità, 26.4.<br />r>
Ermanno Paccagnini, Il Sole 24ore, 11.5.97<br />
                                Angelo Guglielmi, Tuttolibri de La Stampa, 17.4.97<br />
                                Giuliano Gramigna, Il Corriere della sera, 5.7.97<br />
                                Massimo Raffaeli, Il Manifesto, 27.3.97<br />
                                Massimo Onofri, Il Diario della settimana, 18.6.97<br />
                                Claudio Marabini, Weekend (suppl. a Il Giorno, La Nazione, Il Resto del Carlino, 24.4.97<br />
                                Fulvio Panzeri, Avvenire, 29.3.97<br />
                                Giuseppe Amoroso, La Gazzetta del sud, 25.3.97<br />
                                Alessandro Cogolo, Il Gazzettno, 27.7.97<br />
                                Zina Righi, Il Giorno, 20.4.97<br />
                                Silvio Perrella, L?indice dei libri del mese, ottobre 97<br />
                                Grazia Giordani, Brescia Oggi, 17.5.97<br />
                                Fabio De Santi, L'Adige, 21.3.97<br />
                                Anna Maria Eccli, L'Alto Adige, 6.3.97<br />
                                Daniele Piccini, Il Popolo, 25.4.98<br />
                                David Fiesoli, La Gazzetta di Parma, 28.11.97<br />
                                Enrico Mistri, Il Secolo, 14.1.98<br />
                                Grazia Giordani, L'Arena di Verona, 17.5.97<br />
                                F,Sa,, La Notte, 19.5.97<br />
                                Giorgio Chiappini, La Nuova Ferrara, 9.5.98<br />
                                David Fiesoli, Il Tirreno, 30.5.97 <br />
                                Angelo Ferracuti, Il Centro, 23.5.97<br />
                                Enrico Grandesso, Il Gazzettino, 26.4.97<br />
                                Fulvio Panzeri, Avvenimenti, 1.10.97<br />
                                A.G., Panorama, 24.4.97<br />
                                Erminia Dell'Oro, Mai Taclì, giugno <br />r>
Giuseppe Marchetti, Letture, agosto 97<br />
                                Paolo Grassini, La Scrittura, estate 97<br />
                                Roberto Antolini, Il Ponte, aprile 98<br />
                                Francesco Mannoni, Libertà, 17.2.<br />r>
Giacomo Anderle, Vita Trentina, 30.3.97<br />
                                Cristina Nesi, Il Grande Vetro, ottobre 97<br />
                                Luigi Serravalli, QuestoTrentino, 26.4.97<br />



                            </div>

                            <div align="left">
                                <strong>Selezione Stampa</strong>

                                <table border="0" align="center" cellspacing="7">
                                    <tr>
                                        <td align="center" width="100%">  &quot;Due topoi si incontrano nel romanzo&quot; di
Ermanno Paccagnini.(155k)</td>
                                        <td width="100%"><a href=" rec\onore-duetopoi.zip"><img src="./img/rec/onore-duetopoi_small.gif" alt="scarica in formato zip"
                                        ></img></a></td>
                                    </tr>
                                    <tr>
                                        <td align="center" width="100%">  &quot;Il fantasma di un padre in etiopia&quot; di Massimo raffaeli.(726k)</td><td><a href="rec\onore-ilfantasmadiunpadre.zip"><img
                                            src="./img/rec/onore-ilfantasmadiunpadre_small.jpg" alt="scarica in formato zip"
                                        ></img></a></td>
                                    </tr>
                                    <tr>

                                        <td align="center" width="100%">&quot;Fedeli alla linea&quot; di Massimo Onofri.(204k)</td><td><a href="rec\onore-fedeliallalinea.zip"><img
                                            src="./img/rec/onore-fedeliallalinea_small.gif" alt="scarica in formato zip"></img></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" width="100%">Il Corriere della sera,
        5/7/1997: &quot;Sui campi di battaglia del padre&quot; di Giuliano Gramigna.(134k)</td><td><a href="rec\onore-suicampi.zip"><img src="./img/rec/onore-suicampi_small.gif" alt="scarica in formato zip"
                                        ></img></a></td>

                                    </tr>
                                    <tr>


                                        <td align="center" width="100%">La Stampa,
         &quot;Sulle orme del padre&quot; di Angelo Guglielmi.(212k)</td><td><a href="rec\onore-sulleorme.zip"><img src="./img/rec/onore-sulleorme_small.gif" alt="scarica in formato zip"
                                        ></img></a></td>
                                    </tr>
                                    <tr>


                                        <td align="center" width="100%">Weekend(supp. il Giorno La Nazione e Resto del Carlino),
        24/4/1997: &quot;Tamburini in Africa cercando il padre&quot; di Claudio Marabini.(818k)</td><td><a href="rec\onore-tamburiniinafrica.zip"><img src="./img/rec/onore-tamburiniinafrica_small.jpg" alt="scarica in formato zip"
                                        ></img></a></td>
                                    </tr>
                                    <tr>


                                        <td align="center" width="100%">l'Avvenire,
        29/3/1997: &quot;L'Eritrea ferita e la ricerca del padre&quot; di Fulvio Panzeri.(156k)</td><td><a href="rec\onore-l%20eritrea.zip"><img src="./img/rec/onore-l%20eritrea_small.gif" alt="scarica in formato zip"
                                        ></img></a></td>

                                    </tr>



                                </table>
                            </div>














                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                        </div>
                    </div>
                </div>
            </div >


        )
    }
}
